import { gql } from '@apollo/client'

export const UseDocumentFeatureMutation = gql`
  mutation useDocumentFeatureMutation($input: UseDocumentFeatureInput!) {
    useDocumentFeature(input: $input) {
      profile {
        id
      }
    }
  }
`
